import * as React from 'react';
import { ArticleHeading1, ArticleHeading3, ArticleParagraph1 } from '@cian/ui-kit';
import { IBenefit } from '../../types/developer/benefits';
import { BenefitCard as BenefitCardComponent } from '../../components/BenefitCard';

interface IBenefitCardProps {
  benefit: IBenefit;
  index: number;
}

export function BenefitCard({ benefit, index }: IBenefitCardProps) {
  const isFirstCard = index === 0;
  const title = isFirstCard ? (
    <ArticleHeading1 color="text-inverted-default">{benefit.title}</ArticleHeading1>
  ) : (
    <ArticleHeading3 color="text-inverted-default">{benefit.title}</ArticleHeading3>
  );
  const description = isFirstCard ? (
    <ArticleParagraph1 color="text-inverted-default">{benefit.description}</ArticleParagraph1>
  ) : null;

  return <BenefitCardComponent title={title} description={description} backgroundImage={benefit.image} />;
}
